import Vue from 'vue'
import VueRouter, { RouteConfig, RawLocation} from 'vue-router'
import layout from '../views/layout/layout.vue'

Vue.use(VueRouter);

  // 解决跳转同一页面报错
  const originalPush = VueRouter.prototype.push
  VueRouter.prototype.push = function push(location: RawLocation) {
    // @ts-ignore
    return originalPush.call(this, location).catch((err: any) => err)
  };

  const routes: Array<RouteConfig> = [
  {
    path: '/',
    redirect: '/home',
    // component: () => import('../views/layout/layout.vue'),
    component: layout,
    children: [
      {
        path: '/home',
        name: '首页',
        meta: { scrollToTop: true },
        component: () => import('../views/pages/index/index.vue'),
      },
      {
        path: '/production',
        name: '产品',
        meta: { scrollToTop: true },
        component: () => import('../views/pages/production/production.vue'),
      },
      {
        path: '/solution',
        redirect: '/selfService',
        name: '解决方案',
        component: () => import('../views/pages/solution/solution.vue'),
        children: [
          {
            path: '/selfService',
            name: '自助设备',
            component: () => import('../views/pages/solution/selfService.vue'),
          },
          {
            path: '/ITservice',
            name: 'IT设备',
            component: () => import('../views/pages/solution/ITservice.vue'),
          },
          {
            path: '/businessScreen',
            name: '商用显示',
            component: () => import('../views/pages/solution/businessScreen.vue'),
          },
          {
            path: '/guardService',
            name: '安防设备',
            component: () => import('../views/pages/solution/guardService.vue'),
          },
          {
            path: '/intelFurniture',
            name: '智能家居',
            component: () => import('../views/pages/solution/intelFurniture.vue'),
          },
          {
            path: '/workService',
            name: '办公设备',
            component: () => import('../views/pages/solution/workService.vue'),
          },

        ]
      },
      {
        path: '/download',
        name: '下载',
        meta: { scrollToTop: true },
        component: () => import('../views/pages/download/download.vue'),
      },
      {
        path: '/help',
        name: '帮助中心',
        meta: { scrollToTop: true },
        component: () => import('../views/pages/help/help.vue'),
      },
      {
        path: '/about',
        name: '关于我们',
        meta: { scrollToTop: true },
        component: () => import('../views/pages/about/about.vue')
      }
    ],
  },
  {
    path: '/join/:type',
    name: '申请委托商',
    meta: { scrollToTop: true },
    component: () => import('../views/pages/join/corp-join.vue')
  }
];

const scrollBehavior = (to: any, from: any, savedPosition: any) => {
  if (savedPosition) {// 返回之前的原位置
    // savedPosition 当且仅当 popstate 导航 (通过浏览器的 前进/后退 按钮触发) 时才可用。
    return savedPosition;
  } else {
    const position: any = {};
    if (to.hash) {// 如果路径中有哈希值，就采用锚点定位
      position.selector = to.hash;
    }
    // 1.根据是否有meta属性进行判断  2.发生路由重定向直接滚动回顶部
    if (to.matched.some((m: { meta: { scrollToTop: any } }) => m.meta.scrollToTop) || to.redirectedFrom) {
      position.x = 0;
      position.y = 0;
    }
    // 如果返回一个 falsy (假的值)，或者是一个空对象，那么不会发生滚动。
    return position;
  }
};


const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  scrollBehavior,
  routes
});

export default router
